<template>
  <div id="producer-main">
    <span id="title">{{ $t("producerLookup") }}</span>
    <SearchBar 
      :searchPrompt="searchPrompt"
      :firstDataSet="brands" 
      firstDataSetName="brands"
      :secondDataSet="producers"
      secondDataSetName="producers"
      @searchSelected="findResultInfo" 
    />
    <BrandInfo
      v-if="searchResult.setName === 'brands'"
      @searchSelected="findResultInfo"
      :searchResult="searchResult"
      :correspondingNames="matchingProducers" 
    />
    <ProducerInfo
      v-if="searchResult.setName === 'producers'"
      @searchSelected="findResultInfo"
      :searchResult="searchResult"
      :correspondingNames="matchingBrands"
      :sameTownProducers="sameTownProducers" 
    />
    <div id="background-container" :class="{ isHidden: backgroundIsHidden}">
      <img class="still-background" src="@/assets/images/still.svg" :class="{ isHidden: backgroundIsHidden}"/>
    </div>
  </div>
</template>

<script>
import ProducerInfo from "@/components/ProducerInfo.vue"
import BrandInfo from "@/components/BrandInfo.vue"
import SearchBar from "@/components/SearchBar.vue"
import {spanishStillLabels, spanishFermenterLabels} from '@/assets/JSON/data.js'

export default {
  name: 'Producer',
  components: {
    ProducerInfo,
    BrandInfo,
    SearchBar
    
  },
  
  data() {
    return {
      brands: [],
      producers: [],
      brandsToProducers: [],
      stills: [],
      towns: [],
      fermenters: [],
      municipalities: [],
      states: [],
      backgroundIsHidden: false,
      searchResult: {
        name: '',
        fermenter: '',
        still: '',
        setName: '',
        townName: '',
      },
      matchingBrands: [],
      matchingProducers: [],
      sameTownProducers: [],
    }
  },
  async mounted(){
    this.brands = await this.$getItem('brands');
    this.producers = await this.$getItem('producers');
    this.brandsToProducers = await this.$getItem('brandsToProducers');
    this.stills = await this.$getItem('stills');
    this.towns = await this.$getItem('towns');
    this.fermenters = await this.$getItem('fermenters');
    this.municipalities = await this.$getItem('municipalities');
    this.states = await this.$getItem('states');

    if (this.$i18n.i18next.language === 'es'){
      this.convertLabelsToSpanish()
    }

    if (this.$route.query.setName && this.$route.query.id !== undefined){
      const newSearchResult = this.producers.find(producer => producer.id === this.$route.query.id);
      newSearchResult.setName = this.$route.query.setName;
      this.findResultInfo(newSearchResult);
    }
  },
  methods: {
    sortByName(a, b) {
      if (a.name < b.name){
        return -1;
      }

      if (a.name > b.name){
        return 1;
      }
      return 0;
    },
    findResultInfo(searchResult){
      this.searchResult = searchResult;
      window.scrollTo(0,0);

      if (searchResult.setName === 'brands'){
        const joiningIds = this.brandsToProducers.filter(entry => searchResult.id === entry.brand_id);
        const producerIds = joiningIds.map(join => join.producer_id);

        const matchingProducers = this.producers.filter(producer => producerIds.includes(producer.id));
        matchingProducers.forEach(producer => {
          producer.setName = "producers";
          producer.still = this.stills.find(still => still.id === producer.still_id);
          producer.town = this.towns.find(town => town.id === producer.town_id);
          producer.municipality = this.municipalities.find(muni => muni.id === producer.town.municipality_id);
          producer.state = this.states.find(state => state.id === producer.municipality.state_id);
          producer.fermenter = this.fermenters.find(fermenter => fermenter.id === producer.fermenter_id);
        });

        this.matchingProducers = matchingProducers.sort(this.sortByName);

      } else if (searchResult.setName === 'producers'){
        this.searchResult.still = this.stills.find(still => still.id === this.searchResult.still_id);
        this.searchResult.fermenter = this.fermenters.find(ferment => ferment.id === this.searchResult.fermenter_id);
        this.searchResult.town = this.towns.find(town => town.id === this.searchResult.town_id);
        this.searchResult.municipality = this.municipalities.find(muni => muni.id === this.searchResult.town.municipality_id);
        this.searchResult.state = this.states.find(state => state.id === this.searchResult.municipality.state_id);

        const joiningIds = this.brandsToProducers.filter(entry => searchResult.id === entry.producer_id);
        const brandIds = joiningIds.map(join => join.brand_id);

        const matchingBrands = this.brands.filter(brand => brandIds.includes(brand.id));
        matchingBrands.forEach(element => element.setName = "brands");

        this.matchingBrands = matchingBrands.sort(this.sortByName);
        this.findSameTownProducers(this.searchResult.town_id, searchResult.id);
      }
    },
    findSameTownProducers(townId, currentProducerId){
      const sameTownProducers = this.producers.filter(producer => producer.town_id === townId && producer.id != currentProducerId);
      sameTownProducers.forEach(element => element.setName = "producers");
      this.sameTownProducers = sameTownProducers.sort(this.sortByName);
    },
    convertLabelsToSpanish(){
      this.fermenters = spanishFermenterLabels;
      this.stills = spanishStillLabels;
    }
  },
  computed: {
    currentLatLong(){
      return this.$store.state.currentLatLong;
    },
    searchPrompt(){
      if (this.$i18n.i18next.language === 'en'){
        return 'search by mezcalero or brand'
      } else {
        return 'buscar por mezcalero o marca'
      }
    }
  },
  watch: {
    searchResult(newValue){
      if (newValue.name != ''){
        this.backgroundIsHidden = true;
      }
    }
  }

}

</script>

<style lang="scss" scoped>

#producer-main {
  margin: 10px;
}

#title {
  color: grey;
}

.still-background {
  width: 100vw;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15vh;
  filter: invert(.6);
}

#background-container {
  top: 150px;
  z-index: -1;
  position: absolute;
}

#background-container.isHidden, .still-background.isHidden {
  display: none;
}

</style>